<template>
  <PrimevueDialog
    v-model:visible="dialogVisible"
    :modal="true"
    :style="{ width: 'min(760px, calc(100vw - 2rem))' }"
    class="user-settings-dialog"
  >
    <template #header>
      <div class="settings-dialog-header">
        <span class="settings-dialog-icon" aria-hidden="true">
          <i class="fa fa-gear"></i>
        </span>
        <div>
          <h5 class="mb-0">Paramètres</h5>
          <small>Préférences de votre compte</small>
        </div>
      </div>
    </template>

    <div class="settings-dialog-body">
      <PrimevueTabView v-if="dialogVisible">
        <PrimevueTabPanel header="Général">
          <UserSettingsSection
            section="general"
            :show-appearance-settings="showAppearanceSettings"
            :cashier-mode="cashierMode"
          />
        </PrimevueTabPanel>
        <PrimevueTabPanel header="Impression">
          <UserSettingsSection section="printing" :cashier-mode="cashierMode" />
        </PrimevueTabPanel>
        <PrimevueTabPanel header="Inventaire">
          <UserSettingsSection section="inventory" />
        </PrimevueTabPanel>
      </PrimevueTabView>
    </div>
  </PrimevueDialog>
</template>

<script>
import UserSettingsSection from '@/components/UserSettingsSection.vue';

export default {
  name: 'UserSettingsDialog',
  components: {
    UserSettingsSection,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    showAppearanceSettings: {
      type: Boolean,
      default: true,
    },
    cashierMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:visible'],
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
  },
};
</script>

<style scoped>
.settings-dialog-header {
  align-items: center;
  display: flex;
  gap: 0.75rem;
}

.settings-dialog-icon {
  align-items: center;
  background: #eef4ff;
  border-radius: 8px;
  color: #155cff;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.settings-dialog-header small {
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 700;
}

.settings-dialog-body {
  color: #0f172a;
}
</style>
